<template lang="pug">
.acesso-rapido(v-loading='carregando')
    section.acesso-rapido__header.row
        .acesso-rapido__header__title.col-12
            | {{ $t('mensagens.home.acessoRapido.titulo') }}

    section.acesso-rapido__body.row
        .acesso-rapido__body__atalhos.col-12
            Atalho(
                v-for='atalho in atalhos',
                :key='atalho.id',
                :atalho='atalho',
                style='margin-right: 16px',
                @abrirModalAtualizacaoBases='abrirModalAtualizacaoBases()'
            )
            ModalAtualizacaoBases(
                :show='showModalAtualizacaoBases',
                @update:show='showModalAtualizacaoBases = $event'
            )
</template>

<script>
import Atalho from '@/components/home/acessoRapido/Atalho';
import AtalhoService from '@/services/AtalhoService';
import ModalAtualizacaoBases from './ModalAtualizacaoBases.vue';

export default {
    name: 'AcessoRapido',
    components: {
        Atalho,
        ModalAtualizacaoBases
    },
    data() {
        return {
            atalhos: [],
            carregando: true,
            showModalAtualizacaoBases: false
        };
    },

    async mounted() {
        this.buscarAtalhos();
    },

    methods: {
        async buscarAtalhos() {
            this.carregando = true;
            try {
                const { data } = await AtalhoService.buscarAtalhos();
                this.atalhos = data.atalhos;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.home.acessoRapido.erro')
                });
            } finally {
                this.carregando = false;
            }
        },

        abrirModalAtualizacaoBases() {
            this.showModalAtualizacaoBases = true;
        },

        fecharModalAtualizacaoBases() {
            this.showModalAtualizacaoBases = false;
        }
    },
    watch: {
        '$i18n._vm.locale': function () {
            this.buscarAtalhos();
        }
    }
};
</script>

<style scoped lang="scss">
.acesso-rapido {
    margin: 0;

    .acesso-rapido__header {
        margin: 0;

        .acesso-rapido__header__title {
            font-size: 18px;
            font-weight: 700;
            margin-bottom: 3px;
            padding: 0;
        }
    }

    .acesso-rapido__body {
        height: 110px;
        margin: 0;

        .acesso-rapido__body__atalhos {
            height: 110px;
            padding: 0;
            display: flex;
            overflow-x: auto;
        }
    }
}
</style>
